module.exports = __webpack_public_path__ + "119c20e5f6f1cd8eec9888c486b23b5c.pdf";